/**
 * Sync the theme's native country/language switchers with the Orbe Geolocation app.
 *
 * Orbe only knows a visitor confirmed a country when its mdApp_countryCodeDomain
 * cookie is set. Without it, it geolocates on every landing and prompts or
 * redirects the visitor straight back to the store they just left.
 *
 * Cross-store switches can't set that cookie from the origin store, so they hand
 * the choice over in Orbe's own `?oc={ISO}` query param. Orbe's app embed reads it
 * on landing, writes the cookie itself scoped to orbito.getCountryDomain(), and
 * suppresses its popup. Letting Orbe own the write matters: the two storefronts are
 * www.fluevog.com and ca.fluevog.com, and Orbe scopes the cookie to the shared
 * parent (.fluevog.com) rather than to either hostname.
 *
 * Single delegated handler for every switcher in the theme -- the footer settings
 * column and the header drawer -- so the behaviour can't drift between them.
 */
(() => {
  if (window.__fvLocalizationSwitchBound) return;
  window.__fvLocalizationSwitchBound = true;

  const MAX_AGE = 5184000; // 60 days, matching Orbe's default preference duration

  /** The domain Orbe scopes its cookies to, with the fallback Orbe's docs specify. */
  const orbeShopDomain = () => {
    const fallback = window.location.hostname.replace(/^www\./, '');

    return typeof orbito !== 'undefined' && orbito.getCountryDomain
      ? orbito.getCountryDomain() || fallback
      : fallback;
  };

  const setOrbeCookie = (name, value) => {
    if (!value) return;
    document.cookie = `${name}=${encodeURIComponent(value)}; domain=${orbeShopDomain()}; path=/; max-age=${MAX_AGE}`;
  };

  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement)) return;

    const option = select.options[select.selectedIndex];
    if (!option) return;

    if (select.hasAttribute('data-fv-country-select')) {
      const storeUrl = option.getAttribute('data-store-url');
      const countryCode = option.getAttribute('data-country-code');

      // Regions served by the store we're already on have no cross-store URL:
      // record the preference here rather than reloading the page to hand Orbe a param.
      if (!storeUrl) {
        setOrbeCookie('mdApp_countryCodeDomain', countryCode);
        return;
      }

      let url = storeUrl;
      if (countryCode) {
        url += (url.indexOf('?') === -1 ? '?' : '&') + `oc=${encodeURIComponent(countryCode)}`;
      }
      window.location.href = url;
    } else if (select.hasAttribute('data-fv-language-select')) {
      const form = select.closest('form');
      if (!form) return;

      setOrbeCookie('mdApp_showRecommendationLang', select.value);
      form.submit();
    }
  });
})();
